import axios from 'axios';
import toast from 'react-hot-toast';
import { useMutation, useQuery } from 'react-query';
import { ATTACHMENT_URL, BASE_URL } from './urls';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {}
});
apiClient.interceptors.response.use(
  response => response,
  error => {
    if (error.response.status === 401) {
      localStorage.clear()
      // toast.error('نشست کاری شما به اتمام رسید، لطفا دوباره وارد شوید')
      setTimeout(() => { window.location.href = '/login' }
        , 2000)
    }
  })

apiClient.interceptors.request.use(function (config) {
  if (config.headers) config.headers.authorization = localStorage.getItem('AUTH_TOKEN') ?? '';
  return config;
});

export const useGetAttachment = (attachmentId: string) => {
  return useQuery('attachment-' + attachmentId, async () => {
    const res = await apiClient.get(ATTACHMENT_URL(attachmentId));
    return res.data;
  });
};

export function useUploadDocument(attachmentId: string) {
  return useMutation((file: FormData) => apiClient.post(ATTACHMENT_URL(attachmentId), file));
}
